import {getContext} from 'redux-saga/effects'
import callEndpoint from '$src/api/sagas/callEndpoint'
import refreshTokens from '$src/api/endpoints/auth/refresh'
import {IStore} from '$src/bootstrap/Store'
import {LoggedInState} from '$src/auth/types';

// Calls auth/refresh to refresh the tokens. It might fail
export default function* tryRefreshingTokens(): Generator {
  const mstStore: IStore = yield getContext('mstStore')
  const oldAuthState: LoggedInState = mstStore.auth.getState() as any
  let newAuthState
  try {
    newAuthState = yield callEndpoint(refreshTokens, {jwt: oldAuthState.jwt})
  } catch (e) {
    // @todo handle this properly
    console.error(e) // eslint-disable-line
    mstStore.auth.setAsLoggedOut()
    return
  }
  mstStore.auth.setAsLoggedIn({jwt: newAuthState.jwt})
}



// WEBPACK FOOTER //
// ./src/auth/sagas/tryRefreshingTokens.ts